import { createAction, createAsyncAction } from 'typesafe-actions';
import {
  GetTimesheetByIdPayload,
  Timesheet,
  GetTimesheetsParams,
  TimesheetDetail,
  WeeklyTimesheet,
  TimesheetModalType,
  DailyTimesheet,
  WeeklyTimesheetPayload,
  AddDailyTimesheetsPayload,
  GetDailyTimesheetAudit,
  DeleteDailyTimesheetByIdPayload,
} from './types';

export const getTimesheetsAsync = createAsyncAction(
  'timesheet/GET_TIMESHEETS_REQUEST',
  'timesheet/GET_TIMESHEETS_SUCCESS',
  'timesheet/GET_TIMESHEETS_FAILURE',
)<GetTimesheetsParams, { total: number; data: any[] }, Error>();

export const exportCSVTimesheetsAsync = createAsyncAction(
  'timesheet/EXPORT_CSV_TIMESHEETS_REQUEST',
  'timesheet/EXPORT_CSV_TIMESHEETS_SUCCESS',
  'timesheet/EXPORT_CSV_TIMESHEETS_FAILURE',
)<GetTimesheetsParams, any, Error>();

export const getDailyTimesheetsByWeeklyAsync = createAsyncAction(
  'timesheet/GET_DAILY_TIMESHEET_BY_WEEKLY_REQUEST',
  'timesheet/GET_DAILY_TIMESHEET_BY_WEEKLY_SUCCESS',
  'timesheet/GET_DAILY_TIMESHEET_BY_WEEKLY_FAILURE',
)<GetTimesheetByIdPayload, TimesheetDetail, Error>();

export const deleteDailyTimesheetsInWeekByIdAsync = createAsyncAction(
  'timesheet/DELETE_DAILY_TIMESHEET_BY_WEEKLY_REQUEST',
  'timesheet/DELETE_DAILY_TIMESHEET_BY_WEEKLY_SUCCESS',
  'timesheet/DELETE_DAILY_TIMESHEET_BY_WEEKLY_FAILURE',
)<DeleteDailyTimesheetByIdPayload, {}, Error>();

export const getWeeklyTimesheetsByIdAsync = createAsyncAction(
  'timesheet/GET_WEEKLY_TIMESHEET_BY_ID_REQUEST',
  'timesheet/GET_WEEKLY_TIMESHEET_BY_ID_SUCCESS',
  'timesheet/GET_WEEKLY_TIMESHEET_BY_ID_FAILURE',
)<GetTimesheetByIdPayload, TimesheetDetail, Error>();

export const addWeeklyTimesheetAsync = createAsyncAction(
  'timesheet/ADD_WEEKLY_TIMESHEET_REQUEST',
  'timesheet/ADD_WEEKLY_TIMESHEET_SUCCESS',
  'timesheet/ADD_WEEKLY_TIMESHEET_FAILURE',
)<WeeklyTimesheetPayload, any, Error>();

export const addDailyTimesheetsAsync = createAsyncAction(
  'timesheet/ADD_DAILY_TIMESHEETS_REQUEST',
  'timesheet/ADD_DAILY_TIMESHEETS_SUCCESS',
  'timesheet/ADD_DAILY_TIMESHEETS_FAILURE',
)<AddDailyTimesheetsPayload, {}, Error>();

export const getDailyTimesheetAuditAsync = createAsyncAction(
  'timesheet/GET_DAILY_TIMESHEET_CREATE_AUDIT_REQUEST',
  'timesheet/GET_DAILY_TIMESHEET_CREATE_AUDIT_SUCCESS',
  'timesheet/GET_DAILY_TIMESHEET_CREATE_AUDIT_FAILURE',
)<GetDailyTimesheetAudit, void, Error>();

export const setTimesheets = createAction('timesheet/SET_TIMESHEETS')<Array<Timesheet>>();
export const setTimesheetModalType = createAction('timesheet/SET_TIMESHEET_MODAL_TYPE')<TimesheetModalType>();
export const setSelectedTimesheet = createAction('timesheet/SET_SELECTED_TIMESHEET')<WeeklyTimesheet>();
export const setSelectedDailyTimesheet = createAction('timesheet/SET_SELECTED_DAILYTIMESHEET')<DailyTimesheet>();
export const setActiveTimesheetTab = createAction('timesheet/SET_ACTIVE_TIMESHEET_TAB')<number>();
export const setDateRange = createAction('timesheet/SET_DATE_RANGE')<[Date, Date]>();
